import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import HttpError from '../../../utils/fetch/errors/HttpError';
import { packageName, packageVersion } from './package-context';
import { recentWorkClientExperienceV2, recentWorkClientExperienceV3 } from './index';
export function fetchActivitiesWithExperience(_x, _x2) {
  return _fetchActivitiesWithExperience.apply(this, arguments);
}
function _fetchActivitiesWithExperience() {
  _fetchActivitiesWithExperience = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetchActivities, clientVersion) {
    var experience, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          experience = clientVersion === 'v2' ? recentWorkClientExperienceV2() : recentWorkClientExperienceV3();
          _context.prev = 1;
          experience.start();
          experience.addMetadata({
            clientVersion: clientVersion,
            packageName: packageName,
            packageVersion: packageVersion
          });
          _context.next = 6;
          return fetchActivities(experience);
        case 6:
          data = _context.sent;
          experience.success();
          return _context.abrupt("return", data);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          experience.failure({
            metadata: {
              error: exceptionToMetadata(_context.t0)
            }
          });
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return _fetchActivitiesWithExperience.apply(this, arguments);
}
export var exceptionToMetadata = function exceptionToMetadata(e) {
  if (e instanceof HttpError) {
    var _e$xRequestId;
    return _objectSpread(_objectSpread({}, e), {}, {
      xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
      cause: undefined
    });
  }
  return e instanceof Error ? _objectSpread(_objectSpread({}, e), {}, {
    cause: undefined
  }) : 'unknown';
};